module.exports = __webpack_public_path__ + "static/retirement-strategy-breakdown-graphic.5d5b6558.webp";